<template>
    <layout>
        <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
        <div slot="content">
            <div class="pop-content-search">
                <el-form size="mini" label-width="65px">
                    <el-row>
                        <el-col :span="16">
                            <el-form-item label="엑셀파일">
                                <el-col :span="14">
                                <el-input type="text" v-model="file.name" readonly/>
                                <input ref="file" type="file" accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @change="fileChangeEvent" hidden/>
                                </el-col>
                                <el-col :span="8">
                                <el-button type="primary" size="mini" icon="el-icon-files" @click="uploadArea">
                                    {{fileLoaded ? '파일찾기' : '신규 업로드'}}
                                </el-button>
                                </el-col>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-button type="danger" size="mini" icon="el-icon-upload2" @click="uploadFile">
                                업로드
                            </el-button>
                        </el-col>
                        <el-col :span="4">
                            <el-button size="mini" type="primary" icon="el-icon-document-add" @click="save">
                                저장
                            </el-button>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="샘플양식">
                                <el-button size="mini" type="success" icon="el-icon-document-checked" @click="tempDownload">
                                양식 다운
                                </el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <div class="table-area">
                <div class="table-b">
                    <ag-grid-vue 
                        style="width: 100%; height: 320px;"
                        class="ag-theme-alpine"
                        :enableRangeSelection="true"
                                
                        :column-defs="columnDefs"     
                        :grid-options="gridOptions"
                        :row-data="subData"
                        :default-col-def="defaultColDef"
                        @grid-ready="onGridReady"
                        />
                </div>
            </div>

            <div class="table-area" v-show='false'>
              <div class="table-b">
                <ag-grid-vue
                  style="width: 100%; height: 320px;"
                  class="ag-theme-alpine"

                  :column-defs="columnDefsTemp"
                  :grid-options="gridOptionsTemp"
                  :row-data="tempFormData"
                  :default-col-def="defaultColDefTemp"
                />
              </div>
            </div>
        </div>
    </layout>
</template>

<script>
import Layout from '@/components/Slot/ModalSlot.vue';
import {AgGridVue} from 'ag-grid-vue';

/**
 * Url JOIN
 */
 function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}


export default {
    props: {
        tabData: {
            Type: Array
            , required: false
        },
        custNo: {
            Type: String
            , required: false
        }
    },
    components: {Layout, AgGridVue},
    data() {
        return {
            title: 'BOM 엑셀 Upload',

            rowCount:0,
            // enableUploadArea: false,
            file: {
                name: undefined
            },
            fileLoaded: false,
            modelData:[],
            // AG-GRID OPTION [START]
            subData:[],
            tempData:[],
            tempFormData:[],
            gridOptions: {},
            gridOptionsTemp: {},
            maker: '', /** 제조사 */
            makerList: [], /** 제조사 리스트*/
            modelGroup: '', /** 제품군 */
            modelGroupList: [], /** 제품군 리스트*/
            modelGroupNmList: [], /** 제품군 명칭 리스트*/
            subModelGroup: '', /** 제품군 */
            subModelGroupList: [], /** 제품군 리스트*/
            subModelGroupShow: false,
            standardModelNm: '', /** 대표모델 */
            modelNm: '', /** 모델 */
            setupGroupId: '',

            columnDefs:[
                {
                    headerName: '제조사', 
                    width:200,
                    field:'maker',
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '제품군', 
                    width:200,
                    field:'modelGroup',
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '대표모델', 
                    width:200,
                    field:'standardModelNm', 
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '모델', 
                    width:400,
                    field:'modelNm', 
                    cellStyle:{textAlign:'center'}
                },
                {
                  headerName: '품번',
                  width:200,
                  field:'itemCd',
                  cellStyle:{textAlign:'center'}
                },
                {
                  headerName: '품명',
                  width:200,
                  field:'itemNm',
                  cellStyle:{textAlign:'center'}
                },
                {
                  headerName: '규격',
                  width:200,
                  field:'itemSpec',
                  cellStyle:{textAlign:'center'}
                },
                {
                  headerName: '생산일자',
                  width:200,
                  field:'prodDt',
                  cellStyle:{textAlign:'center'}
                },
                {
                  headerName: '소요량',
                  width:200,
                  field:'itemQty',
                  cellStyle:{textAlign:'center'}
                },
            ],
            columnDefsTemp:[
            {
              headerName: '제조사',
              width:200,
              field:'maker',
              cellStyle:{textAlign:'center'}
            },
            {
              headerName: '제품군',
              width:200,
              field:'modelGroup',
              cellStyle:{textAlign:'center'}
            },
            {
              headerName: '대표모델',
              width:200,
              field:'standardModelNm',
              cellStyle:{textAlign:'center'}
            },
            {
              headerName: '모델명',
              width:400,
              field:'modelNm',
              cellStyle:{textAlign:'center'}
            },
            {
              headerName: '품번',
              width:200,
              field:'itemCd',
              cellStyle:{textAlign:'center'}
            },
            {
              headerName: '품명',
              width:200,
              field:'itemNm',
              cellStyle:{textAlign:'center'}
            },
            {
              headerName: '규격',
              width:200,
              field:'itemSpec',
              cellStyle:{textAlign:'center'}
            },
            {
              headerName: '단위',
              width:200,
              field:'itemSpec',
              cellStyle:{textAlign:'center'}
            },
            {
              headerName: '생산일자',
              width:200,
              field:'prodDt',
              cellStyle:{textAlign:'center'}
            },
            {
              headerName: '소요량',
              width:200,
              field:'itemQty',
              cellStyle:{textAlign:'center'}
            },
          ],
            defaultColDef: { 
                resizable: true, 
                filter:true, 
                sortable: true 
            },
            defaultColDefTemp: {
              resizable: true,
              filter:true,
              sortable: true
            },
            form: {}
        }
    },
    mounted() {
        // this.form = this.tabData[0] ? this.tabData[0].param : {}

    },
    methods: {
        // showEnableUploadArea() {
        //     this.enableUploadArea = this.enableUploadArea ? false : true
        // },
        uploadArea() {
            if(!this.fileLoaded) {
            this.$confirm('BOM정보 엑셀 파일 업로드를 진행 하시겠습니까?', '파일 업로드', {
                    confirmButtonText: '확인',
                    cancelButtonText: '취소',
                    type: 'info'
                }).then(() => {
                    this.searchFile();
                }).catch(err => {
                    this.$message({
                        type: 'warning',
                        message: '취소되었습니다.'
                    });
                })
            } else {
                this.searchFile();
            }
        },
        searchFile() {
            this.$refs.file.click()
        },
        fileChangeEvent() {
            this.file = this.$refs.file.files[0] || {
                name: undefined
            }
            this.fileLoaded = this.$refs.file.files[0] !== undefined
        },
        uploadFile() {
            if (this.fileLoaded) {
                let form = new FormData();
                form.append('file', this.file);

                this.$store.commit('loading');
                this.$http.post('/api/bomMng/excel/temp/upload', form, {timeout: 60000*60},{
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    this.$swal({
                        type: 'success',
                        text: response.data
                    }).then(this.query)
                      if (response.data.length == 0){
                        this.$swal({
                          type: 'error',
                          html: '오류가 발생했습니다. <br> 제조사,제품군,대표모델,모델명,품번은 필수 입력 값입니다.'
                        });
                      }else{
                        this.$swal({
                          type: 'success',
                          text: '업로드에 성공했습니다.'
                        });
                      }
                      this.subData = response.data;
                    return response;
                }).catch(e => {
                  this.$swal({type: 'error', text: e.response.data.message});
                    return e;
                }).finally(() => {
                    // this.enableUploadArea = false;
                    this.$store.commit('finish');
                })
            } else {
                this.$swal({
                    type: 'warning',
                    text: '업로드할 파일을 선택해주세요.'
                })
            }
        },

        
        closeModal() {
            this.$parent.close();
        },
        onGridReady(){
            this.init();
            // this.getCombo({flag: 'INIT'})
        },
        rowDoubleClick(params){
            this.$emit('close', params.data);
        },
        getCombo(param) {
            if(param.flag === 'INIT'){
                // 제조사
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: 196}})
                    .then(response => {
                        this.makerList = response.data || []
                        this.makerList.unshift({key:'', value:'전체'})
                    });

                // 제품군 : ModelGroup, CAT_LVL(2)
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: 143}})
                    .then(response => {
                        this.modelGroupNmList = response.data || []
                        this.modelGroupNmList.unshift({key:'', value:'전체'})
                    });
                // 제품군 : ModelGroup, CAT_LVL(2)
                this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: 143}})
                    .then(response => {
                        this.modelGroupList = response.data || []
                        this.modelGroupList.unshift({key:'', value:'전체'})
                        
                    });
            } else {
                if(param.parentId === ''){
                    this.subModelGroupShow =  false
                } else{
                    this.subModelGroupShow =  true

                    // 하위 제품군 : ModelGroup, CAT_LVL(2)
                    this.$http.get(`/api/codeMng/combo`, {params: {parentId: param.parentId}})
                        .then(response => {
                            this.subModelGroupList = response.data || []
                            this.subModelGroupList.unshift({key:'', value:'전체'})
                            this.subModelGroup = ''
                        });
                }
                
            } 
        },
        onModelGroupChange(e){
            // console.log('onModelGroupChange start====', e.target)
            // 모델이 변경시 하위 제품군 조회
            this.getCombo({flag: '', parentId: e.target.value})
        },
        selectTmpBomDataList(data){
            /** 업로드후 템프 테이블의 데이터 인설트 */
            const vform = data;
            this.$store.commit('loading')
            this.$http.post(("/api/bomMng/excel/bom/upload"), vform
                ).then(response => {
                    this.subData = response.data || []
                }).finally(() => {
                    this.$store.commit('finish')
                });
        },
        tempDownload(){
          this.gridOptionsTemp.api.exportDataAsExcel({fileName: 'BOM 양식'});
        },
        init(){
          this.$store.commit('loading');
          this.$http.post(`/api/bomMng/init`)
              .then(response => {
                this.modelData = response.data.modelGroup;
              }).finally(() => {
            //this.goOpen();
            this.$store.commit('finish');
          });
        },
        save(){

            if(this.subData.length <= 0){
                this.$swal({ type: 'warning', text: '업로드데이타가 없습니다. 신규업로드후에 저장하시기 바랍니다.' })
                return false;
            }

            this.$swal({
                type: 'warning',
                text: `엑셀Upload를 저장하시겠습니까?`,
                showCancelButton: true,
                confirmButtonText: '예',
                cancelButtonText: '아니오',
            }).then((result) => {
                if (result.value) {
                    this.$store.commit('loading')

                    this.subData.forEach(x=>{
                      if(x.itemQty == '') x.itemQty = 0;
                      this.modelData.forEach(y=>{ if(y.value === x.modelGroup) x.modelGroup = y.key});
                    });

                    const vform = this.subData;
                    
                    this.$http.post(_url("/api/bomMng/excel/bom/upload"), vform)
                        .then(response => {
                            this.$swal({ type: 'success', text: '저장되었습니다.' });
                            this.closeModal();

                        }).catch((e) => {
                            console.error(e);
                            this.$swal({ type: 'error', text: '저장에 실패 했습니다.' });
                        })
                        .finally(() => {
                            this.$store.commit('finish');
                        });

                }
            });
 
        }
    }
}
</script>

<style lang="scss" scoped>
// .modal-card {
//   width: 970px;
// }

// .display-area {
//   :global(img) {
//     width: 100%;
//   }
// }
</style>